var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-center text-center my-4" },
    [
      _c("v-divider", { staticClass: "flex-grow-1" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mx-4 grey--text text--darken-2 text-caption font-weight-regular",
        },
        [
          _vm.text
            ? _c("span", {
                staticStyle: { "font-size": "14px" },
                domProps: { innerHTML: _vm._s(_vm.text) },
              })
            : _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "flex-grow-1" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }